import { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import "./Offer.css";
import AddOfferModal from './AddOfferModal';
import { useNavigate } from 'react-router-dom';
import { BACKEND_URL } from '../../../services/Helper';
import { toast } from 'react-toastify';

function ConfirmModal({ title, sub, onConfirm, onCancel }) {
    return (
        <div className="confirm-overlay" onClick={onCancel}>
            <div className="confirm-card" onClick={e => e.stopPropagation()}>
                <div className="confirm-icon">🗑️</div>
                <div className="confirm-title">{title}</div>
                {sub && <div className="confirm-sub">{sub}</div>}
                <div className="confirm-btns">
                    <button className="confirm-yes" onClick={onConfirm}>Yes, Delete</button>
                    <button className="confirm-no" onClick={onCancel}>Cancel</button>
                </div>
            </div>
        </div>
    );
}

const Offer = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alloffer, setAllOffer] = useState([]);
    const [deletingId, setDeletingId] = useState(null);
    const [confirmModal, setConfirmModal] = useState(null);
    const [editingOffer, setEditingOffer] = useState(null);

    const fetchMyOffer = async () => {
        try {
            const token = localStorage.getItem("shoplogintoken");
            if (!token) {
                toast.error("You must be logged in to get your offers");
                navigate('/shoplogin');
                return;
            }
            const res = await fetch(`${BACKEND_URL}/nearbe/myoffers`, {
                method: "GET",
                headers: { Authorization: token },
            });
            const data = await res.json();
            setAllOffer(data.myOffers);
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong!");
        }
    };

    useEffect(() => {
        fetchMyOffer();
    }, []);

    const handleDeleteOffer = async (offerId) => {
        try {
            setDeletingId(offerId);
            const token = localStorage.getItem("shoplogintoken");
            if (!token) {
                toast.error("You must be logged in to delete offer");
                navigate('/shoplogin');
                return;
            }
            const res = await fetch(`${BACKEND_URL}/nearbe/deleteofferitem/${offerId}`, {
                method: "DELETE",
                headers: { Authorization: token },
            });
            const data = await res.json();
            if (!res.ok) {
                toast.error(data.message || "Delete failed");
                return;
            }
            toast.success("Offer deleted");
            setAllOffer((prev) => prev.filter((offer) => offer._id !== offerId));
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong!");
        } finally {
            setDeletingId(null);
        }
    };

    return (
        <div className='offerhai'>
            <Navbar />
            <div className='offer_contain'>
                <div className='offer-upper'>
                    <h2>General Offers</h2>
                    <button className='add-offer' onClick={() => setIsModalOpen(true)}>
                        + Add New Offer
                    </button>
                </div>

                <div className='offer-item'>
                    {alloffer.length === 0 ? (
                        <p className="no-offer-msg">🚫 No offers yet — create your first one!</p>
                    ) : (
                        alloffer.map((offer) => (
                            <div key={offer._id} className="offer-card">
                                <div className="offer-header">
                                    <h3>{offer?.title}</h3>
                                    <span className="status active">Active</span>
                                </div>
                                <p className="offer-description">{offer?.description}</p>
                                <p className="offer-validity">
                                    📅 Valid until:{" "}
                                    {new Date(offer?.validTill).toLocaleDateString("en-IN", {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                    })}{" "}
                                    ({offer?.endTime})
                                </p>
                                <div className="offer-actions">
                                    <button
                                        className="edit-btn"
                                        onClick={() => {
                                            setEditingOffer(offer);
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="delete-btn"
                                        onClick={() => setConfirmModal({ id: offer._id, name: offer.title })}
                                        disabled={deletingId === offer._id}
                                    >
                                        {deletingId === offer._id ? "Deleting..." : "Delete"}
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {isModalOpen && (
                <AddOfferModal
                    onClose={() => {
                        setIsModalOpen(false);
                        setEditingOffer(null);
                    }}
                    editingOffer={editingOffer}
                    onOfferAdded={(newOffer) => setAllOffer((prev) => [newOffer, ...prev])}
                    onOfferUpdated={(updatedOffer) =>
                        setAllOffer((prev) =>
                            prev.map((o) => (o._id === updatedOffer._id ? updatedOffer : o))
                        )
                    }
                />
            )}

            {confirmModal && (
                <ConfirmModal
                    title={`Delete "${confirmModal.name}"?`}
                    sub="This offer will be permanently removed and customers won't see it anymore."
                    onConfirm={() => {
                        const id = confirmModal.id;
                        setConfirmModal(null);
                        handleDeleteOffer(id);
                    }}
                    onCancel={() => setConfirmModal(null)}
                />
            )}
        </div>
    );
};

export default Offer;
